import { render, staticRenderFns } from "./VolumeDiscountsList.vue?vue&type=template&id=e2139c6c"
import script from "./VolumeDiscountsList.vue?vue&type=script&lang=js"
export * from "./VolumeDiscountsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports